/* eslint-disable sonarjs/cognitive-complexity */
import React from 'react';
import { useDisplay } from '../../hook/useDisplay';
import { ButonCTA, ContentWraper, Text, Wrapper } from './modal-ddetail-style';

function InformationsDetail({ empretecSelected, closeModalToSSubscription }) {
  const { isLargeDisplay } = useDisplay();

  return (
    <Wrapper bgColor={empretecSelected?.bgColorInformations}>
      <ContentWraper>
        <img
          src={empretecSelected?.logoEmpretec}
          style={{
            width: '180px',
          }}
          alt="img-empretec"
        />

        <div id="texts">
          {empretecSelected?.detailDescription?.map((item, index) =>
            typeof item === 'string' ? (
              <Text
                colorText={
                  empretecSelected?.moduleId === 2 ? '#121A21' : '#fff'
                }
                key={index}
              >
                {item}
              </Text>
            ) : (
              React.cloneElement(item, { key: index })
            ),
          )}
        </div>

        <ButonCTA
          colorText={empretecSelected?.bgColorInformations}
          onClick={() => closeModalToSSubscription()}
        >
          {empretecSelected?.textButtonCta}
        </ButonCTA>
      </ContentWraper>

      {isLargeDisplay() ? (
        <img
          src={empretecSelected?.imgEmpretecLargeDisplay}
          alt="img-empre2ec"
        />
      ) : (
        <img
          src={empretecSelected?.imgEmpretecDetailSmallDisplay}
          alt="img-empre2ec"
        />
      )}
    </Wrapper>
  );
}

export default InformationsDetail;
